<template>
  <sl-table :enable-pager="false" :columns="columns" :data="data"></sl-table>
</template>
<script>
  import { datetime } from '@/util/index'
  export default {
    data(){
      const operation = ({remark , operateMsg}) => (remark + ( operateMsg ? ('：' + operateMsg) : '' ))

      return {
        columns:[
          {
            title:'时间',
            key:'createDatetime',
            render: (h, params) => {
              return h('span', datetime(params.row.createDatetime))
            }
          },
          // {
          //   title: '经办人',
          //   key: 'operateUser'
          // },
          {
            title: '操作',
            key: 'operation',
            render: (h, params) => {
              return h('strong', operation(params.row))
            }
          }
        ]
      }
    },

    props:{
      data:{
        type:Array,
        default:function(){
          return []
        }
      }
    }
  }
</script>